<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
    :content-class="
      `normal-dialog ${contentClass} ${
        fullHeight ? 'normal-dialog--full-height' : ''
      }`
    "
  >
    <v-card>
      <v-card-title class="headline normal-dialog__title">{{
        title
      }}</v-card-title>
      <v-card-text v-if="description">{{ description }}</v-card-text>
      <v-card-text class="normal-dialog__content">
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions">
          <v-btn
            rounded
            text
            :color="color"
            elevation="0"
            :disabled="cancelDisabled"
            @click="cancel"
          >
            {{ cancelText }}
          </v-btn>
          <v-btn
            rounded
            :class="submitBtnClass"
            :color="color"
            elevation="0"
            :disabled="submitDisabled"
            :loading="loadingButtons"
            @click="submit"
          >
            {{ submitText }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NormalDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    submitText: {
      type: String,
      default: 'Submit',
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 290,
    },
    color: {
      type: String,
      default: 'primary',
    },
    submitBtnClass: {
      type: String,
      default: '',
    },
    loadingButtons: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: '',
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  methods: {
    submit() {
      this.$emit('submit')
    },
    cancel() {
      this.dialog = false
      this.$emit('cancel')
    },
    onClickOutside() {
      this.cancel()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.cancel()
    },
  },
}
</script>

<style lang="scss">
.normal-dialog {
  &__title {
    word-break: normal;
  }
  &--full-height {
    &,
    > .v-card {
      height: 100%;
    }
    > .v-card > .v-card__text {
      flex: 1;
    }
  }
}
</style>
